import { useState, useEffect } from "react";

const STORAGE_KEY = "jussbot_app_promo_dismissed_at";
/** Hvor mange dager før vi viser promo igjen etter at bruker har lukket */
const DAYS_UNTIL_SHOW_AGAIN = 1;

// Android: faktisk Play Store-lenke til Jussbot
const PLAY_STORE_URL = "https://play.google.com/store/apps/details?id=com.Jussbotapp1";
const APP_STORE_URL = "https://apps.apple.com/no/app/jussbot/id6759497939";

function isMobileDevice() {
  if (typeof navigator === "undefined") return false;
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent
  );
}

export default function MobileAppPromo() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!isMobileDevice()) return;

    const dismissedAt = localStorage.getItem(STORAGE_KEY);
    if (!dismissedAt) {
      setVisible(true);
      return;
    }

    const elapsedDays = (Date.now() - Number(dismissedAt)) / (1000 * 60 * 60 * 24);
    if (elapsedDays >= DAYS_UNTIL_SHOW_AGAIN) {
      setVisible(true);
    }
  }, []);

  // Legg til/ta bort klasse på body når promo er synlig,
  // slik at vi kun legger til ekstra bunnpadding når banneret faktisk vises.
  useEffect(() => {
    if (!isMobileDevice()) return;
    const body = document.body;
    if (visible) {
      body.classList.add("has-mobile-promo");
    } else {
      body.classList.remove("has-mobile-promo");
    }
    return () => {
      body.classList.remove("has-mobile-promo");
    };
  }, [visible]);

  const handleDismiss = () => {
    localStorage.setItem(STORAGE_KEY, String(Date.now()));
    setVisible(false);
  };

  if (!visible) return null;

  const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);
  const isAndroid = /Android/i.test(navigator.userAgent);
  const qrUrl = encodeURIComponent(isAndroid ? PLAY_STORE_URL : APP_STORE_URL);
  const qrImageSrc = `https://api.qrserver.com/v1/create-qr-code/?size=120x120&data=${qrUrl}`;

  // Android og iOS: vis knapp + QR til riktig butikk.
  const showStoreAndQr = isAndroid || isIOS;

  return (
    <div
      className="mobile-app-promo"
      role="dialog"
      aria-label="Last ned Jussbot-appen"
    >
      <div className="mobile-app-promo-inner">
        <div className="mobile-app-promo-content">
          <p className="mobile-app-promo-title">
            {isIOS ? "📱 Last ned Jussbot-appen på iPhone og iPad" : "📱 Last ned Jussbot-appen"}
          </p>
          <p className="mobile-app-promo-text">
            Last ned appen for en bedre opplevelse på mobil.
          </p>
          {showStoreAndQr && (
          <div className="mobile-app-promo-actions">
            {isAndroid && (
              <a
                href={PLAY_STORE_URL}
                className="mobile-app-promo-btn"
                target="_blank"
                rel="noopener noreferrer"
              >
                Åpne i Play Store
              </a>
            )}
            {isIOS && (
              <a
                href={APP_STORE_URL}
                className="mobile-app-promo-btn"
                target="_blank"
                rel="noopener noreferrer"
              >
                Åpne i App Store
              </a>
            )}
            {!isAndroid && !isIOS && (
              <>
                <a
                  href={PLAY_STORE_URL}
                  className="mobile-app-promo-btn"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Android
                </a>
                <a
                  href={APP_STORE_URL}
                  className="mobile-app-promo-btn"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  iOS
                </a>
              </>
            )}
          </div>
          )}
        </div>
        {showStoreAndQr && (
        <div className="mobile-app-promo-qr">
          <img src={qrImageSrc} alt="QR-kode til appnedlasting" width={100} height={100} />
          <span className="mobile-app-promo-qr-label">Skann for å laste ned</span>
        </div>
        )}
      </div>
      <button
        type="button"
        className="mobile-app-promo-close"
        onClick={handleDismiss}
        aria-label="Lukk og fortsett på nettsiden"
      >
        Fortsett på nettsiden
      </button>
    </div>
  );
}
